import { NavigationContext } from '@layout/navigation/navigation';
import { IAssetLog } from '@models/AssetLog.model';
import { getActivityHistory } from '@services/queries/ActivityHistory';
import { createContext, useContext, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { useInfiniteQuery } from 'react-query';
import { ActivityHistoryRaw } from './ActivityHistory.raw';

export interface IActivityHistoryContext {
  ActivityHistoryData?: IAssetLog[];
  isLoading: boolean;
  ref?: (node?: Element | null | undefined) => void;
  hasMore?: boolean;
}

export const ActivityHistoryContext = createContext<IActivityHistoryContext>({
  isLoading: true,
});

export const ActivityHistoryQuery = () => {
  const { studioId } = useContext(NavigationContext);

  const {
    data,
    isLoading,
    isError,
    fetchNextPage: newFetchNextPage,
  } = useInfiniteQuery(
    ['activity', studioId],
    async ({ pageParam = 1 }) => {
      const activityList = await getActivityHistory({
        studioId,
        pagination: {
          page: pageParam,
          limit: 20,
        },
      });
      return activityList;
    },
    {
      getPreviousPageParam: undefined,
      getNextPageParam: lastPage =>
        lastPage.hasMore ? lastPage.currentPage + 1 : undefined,
    },
  );

  const ActivityHistoryData = data
    ? data.pages
        .map(pageData => pageData.results)
        .reduce(function reduce(prev, next) {
          return prev.concat(next);
        })
    : [];

  const hasMore = data ? data.pages[data.pages.length - 1].hasMore : false;

  const { ref, inView } = useInView();

  useEffect(() => {
    if (inView && hasMore) newFetchNextPage();
  }, [inView, hasMore]);

  if (!data || isError) {
    <div>Error on load activity history</div>;
  }

  return (
    <ActivityHistoryContext.Provider
      value={{
        ActivityHistoryData,
        isLoading,
        ref,
      }}
    >
      <ActivityHistoryRaw />
    </ActivityHistoryContext.Provider>
  );
};
